import React from 'react'

import './Loading.css'

function Loading() {
    return (
        <div className='Spinner' />
    )
}

export default Loading